import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck'

const BASE_CLASS = 'mt-actionAdFavorite-priceDropButton'
const LABEL_CLASS = 'mt-actionAdFavorite-priceDropButtonLabel'

const PriceDropAction = ({commonButtonProps, isMenu}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const URL_STATICS = config.get('urlStatics')

  const priceDropAnimationIcon = `${URL_STATICS}images/price-drop-button-icon-animation.gif`

  const isTabletOrWider = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !isMobile
  })

  const buttonProps = {
    ...commonButtonProps,
    fullWidth: !isTabletOrWider || isMenu,
    shape: atomButtonShapes.CIRCULAR,
    design: isMenu ? atomButtonDesigns.FLAT : atomButtonDesigns.OUTLINE,
    size: atomButtonSizes.LARGE
  }

  return (
    <AtomButton {...buttonProps}>
      <div className={`${BASE_CLASS}InnerWrapper`}>
        <div className={`${BASE_CLASS}Icon`}>
          <AtomImage src={priceDropAnimationIcon} alt="" />
        </div>
        {i18n.t('COMMON.PRICE_DROP.BUTTON')}
      </div>
    </AtomButton>
  )
}

const AlreadyFavorited = ({isMenu}) => {
  const {i18n} = useContext(Context)

  const classNames = cx(BASE_CLASS, {
    'is-menu': isMenu
  })

  const label = i18n.t('COMMON.PRICE_DROP.LABEL_ADDED_FEEDBACK')

  return (
    <div className={classNames}>
      <IconCircleCheck size="medium" />
      <label className={LABEL_CLASS}>{label}</label>
    </div>
  )
}

const ActionAdFavoritePriceDropButton = ({isMenu, isMarked, commonButtonProps}) =>
  isMarked ? (
    <AlreadyFavorited isMenu={isMenu} />
  ) : (
    <PriceDropAction commonButtonProps={commonButtonProps} isMenu={isMenu} />
  )

ActionAdFavoritePriceDropButton.propTypes = {
  commonButtonProps: PropTypes.object,
  isMenu: PropTypes.bool,
  isMarked: PropTypes.bool
}
PriceDropAction.propTypes = {
  commonButtonProps: PropTypes.object,
  isMenu: PropTypes.bool
}

AlreadyFavorited.propTypes = {
  isMenu: PropTypes.bool
}

export default ActionAdFavoritePriceDropButton
